import { DatasetPlaceholder } from "~/pages/manifold-nextgen/components/datasets/DatasetPlaceholder";

export const DatasetTables = () => <DatasetPlaceholder label="Tables" />;
